/**
 * Format time (seconds) to MM:SS format
 */
export const formatTime = (timeInSeconds: number): string => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

/**
 * Format time (seconds) to MM:SS.t format for timeline precision
 */
export const formatTimePrecise = (timeInSeconds: number): string => {
  const safeTime = Number.isFinite(timeInSeconds) ? Math.max(0, timeInSeconds) : 0;
  const minutes = Math.floor(safeTime / 60);
  const seconds = Math.floor(safeTime % 60);
  const tenths = Math.floor((safeTime - Math.floor(safeTime)) * 10);
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${tenths}`;
};

/**
 * Build timeline readout string: current / total (-remaining)
 */
export const formatTimelineWindow = (currentTime: number, duration: number): string => {
  const safeDuration = Number.isFinite(duration) ? Math.max(0, duration) : 0;
  const safeCurrent = Number.isFinite(currentTime)
    ? Math.min(Math.max(0, currentTime), safeDuration || currentTime)
    : 0;
  const remaining = Math.max(safeDuration - safeCurrent, 0);

  return `${formatTimePrecise(safeCurrent)} / ${formatTimePrecise(safeDuration)} (-${formatTimePrecise(remaining)})`;
};
